import * as React from 'react';

export function hasPrimitiveDescription(children: React.ReactNode, displayName: string): boolean {
  let found = false;
  React.Children.forEach(children, (child) => {
    if (found || !React.isValidElement(child)) return;
    const type = child.type as { displayName?: string; name?: string };
    if (type.displayName === displayName || type.name === displayName) {
      found = true;
      return;
    }
    const props = child.props as { children?: React.ReactNode };
    if (props.children) {
      found = hasPrimitiveDescription(props.children, displayName);
    }
  });
  return found;
}
